import { Audit_Log } from "./audit_log";

export class Location {
  location_Id = 0;
  location_Name = '';
  company_Id = 0;
  address_1 = '';
  address_2 = '';
  address_3 = '';
  address_4 = '';
  county = '';
  post_code = '';
  telephone = '';
  fax = '';
  email = '';
  managed = false;
  updated_For_PDA_Sync = '';
  expired = false;
  region_Id = 0;

  audit_Log = new Audit_Log();
  is_edit: boolean;
  distribution_Id = 0;
}
